import React, { useCallback, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import POSITION = toast.POSITION;
import styles from './Dropzone.module.css';
import { useTranslation } from '../../../hooks/useTranslations';

const FileDropZone: React.FC<{ onFilesDropped: (files: File) => void }> = ({ onFilesDropped }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [fileType, setFileType] = useState<string>('');
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const { translations } = useTranslation();
  const handleDrop = useCallback(
    (e: React.DragEvent<HTMLDivElement>) => {
      e.preventDefault();
      setIsDragging(false);
      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        onFilesDropped(files[0]);
        setFileType(files[0].type);
      }
    },
    [onFilesDropped]
  );

  const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback(() => {
    setIsDragging(false);
  }, []);

  const handleFileClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onFilesDropped(files[0]);
      setFileType(files[0].type);
    }
  };

  useEffect(() => {
    if (fileType) {
      if (!fileType.includes('pdf') && !fileType.includes('image')) {
        toast.error(translations('label.your_file'), { position: POSITION.BOTTOM_RIGHT });
      }
    }
  }, [fileType]);

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onClick={handleFileClick}
      style={{ border: '2px dashed #C9D3EA', borderRadius: 10, margin: 20 }}
    >
      <div className={styles.addDocumentsContainer}>
        <input
          type="file"
          ref={inputRef}
          style={{ display: 'none' }}
          onChange={handleInputChange}
        />
        <i className={styles.addDocuments} />
        <div className={styles.uploadText}>
          <p>
            {isDragging
              ? translations('upload.release_to_drop')
              : translations('upload.click_here_or')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FileDropZone;
